module.exports = __webpack_public_path__ + "img/max-file-sync--xml.4e3b60d3.svg";